module.exports = __webpack_public_path__ + "static/media/globe-min.d9738714.png";